import { IdentityState, User } from "contexts/identity-context";

const resolveIdentityId = (identityState: IdentityState) => {
  identityState = identityState as User;
  return identityState.organisations.filter((x) => x.active)[0].organisationId;
};

export { resolveIdentityId };
